export default {"src":"/_next/static/media/AllThatApply.8c8cba80.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};